import React, {Component} from 'react'

export class Promo extends Component {
    render() {
        return(
            <section id="promo">
                <div className="row">
                    <div className="col-md-2"></div>
                    <div className="col-md-8">
                        <div>
                            <p className="font-weight-bold">ICISTS 2019<br />Science in a Nutshell</p>
                        </div>
                    </div>
                    <div className="col-md-2"></div>
                </div>
            </section>
        )
        }
}

export default Promo